import { render, staticRenderFns } from "./BrokerVolunteers.vue?vue&type=template&id=2c916c62"
import script from "./BrokerVolunteers.vue?vue&type=script&lang=ts"
export * from "./BrokerVolunteers.vue?vue&type=script&lang=ts"
import style0 from "./BrokerVolunteers.vue?vue&type=style&index=0&id=2c916c62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports